import * as React from 'react'
import MUIDialogContentText from '@mui/material/DialogContentText'

const DialogContentText = (props) => <MUIDialogContentText {...props} />

export default DialogContentText
